<div class="error-page">
    <div class="error-page__404 text-primary-color">
        404
    </div>
    <h1 [innerHTML]="'error404.title' | translate"></h1>
    <p [innerHTML]="'error404.text' | translate"></p>
    <p [innerHTML]="'error404.backlinkText' | translate"></p>
</div>
